import {
  LanguageCode,
  LanguageName,
  languages as supportedLanguages,
} from 'app/utils/supportedLanguages';

/**
 * Languages supported for CSAT that are not part of the main supported
 * languages list. This is the single source of truth — the types and the
 * runtime list below are both derived from it.
 */
const csatSpecificLanguages = [
  { code: 'sq', label: 'Albanian' },
  { code: 'id', label: 'Indonesian' },
  { code: 'fa', label: 'Persian' },
  { code: 'vi', label: 'Vietnamese' },
] as const;

type CSATSpecificLanguageCode = (typeof csatSpecificLanguages)[number]['code'];
type CSATSpecificLanguageName = (typeof csatSpecificLanguages)[number]['label'];

export type SupportedCSATLanguageCode = LanguageCode | CSATSpecificLanguageCode;

export type SupportedCSATLanguage = {
  code: SupportedCSATLanguageCode;
  label: LanguageName | CSATSpecificLanguageName;
};

/**
 * The list of supported languages specifically for Email CSAT and Phone-SMS
 * CSAT settings. Deduplicated by code (main languages win) and sorted by label.
 */
export const csatLanguages: ReadonlyArray<SupportedCSATLanguage> = [
  ...new Map<SupportedCSATLanguageCode, SupportedCSATLanguage>(
    [...supportedLanguages, ...csatSpecificLanguages].map((item) => [
      item.code,
      item,
    ]),
  ).values(),
].sort((a, b) => a.label.localeCompare(b.label));
